import { render, staticRenderFns } from "./StyledRadioGroup.vue?vue&type=template&id=621a4780&"
import script from "./StyledRadioGroup.vue?vue&type=script&lang=js&"
export * from "./StyledRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./StyledRadioGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports